import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Companies from "./Companies";
import Contacts from "./Contacts";
import { Building2, Users } from "lucide-react";

export default function Customers() {
  return (
    <div className="w-full min-h-[calc(100vh-6rem)] flex flex-col p-8 bg-white rounded-[32px] shadow-[0_4px_40px_-12px_rgba(0,0,0,0.06)] border border-slate-200/60">
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-indigo-100 p-2.5 rounded-2xl">
              <Users className="h-7 w-7 text-indigo-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900 tracking-tight">
              Clientes
            </h1>
          </div>
          <p className="text-slate-500 text-sm md:text-base ml-1">
            Gestiona tus empresas y contactos desde un solo lugar.
          </p>
        </div>
      </div>

      <Tabs defaultValue="companies" className="w-full">
        <TabsList className="flex w-fit bg-slate-100/80 p-1.5 rounded-2xl mb-8">
          <TabsTrigger 
            value="companies" 
            className="flex items-center gap-2 rounded-xl px-6 py-2.5 data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-indigo-600 font-medium transition-all"
          >
            <Building2 className="w-4 h-4" />
            Empresas
          </TabsTrigger>
          <TabsTrigger 
            value="contacts" 
            className="flex items-center gap-2 rounded-xl px-6 py-2.5 data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-indigo-600 font-medium transition-all"
          >
            <Users className="w-4 h-4" />
            Contactos
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="companies" className="mt-0 border-none p-0 outline-none animate-in fade-in-50 duration-500">
          <Companies />
        </TabsContent>
        
        <TabsContent value="contacts" className="mt-0 border-none p-0 outline-none animate-in fade-in-50 duration-500">
          <Contacts />
        </TabsContent>
      </Tabs>
    </div>
  );
}
